export enum ContactsInfo {
    Terms = 'terms',
    Privacy = 'privacy',
    Faq = 'faq',
    Company = 'company',
    Transport = 'transport',
    Payment = 'payment',
    Cookie = 'cookie',
    Impressum = 'impressum',
    Datenschutzerklaerung = 'datenschutzerklaerung'

}